import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\User\CreateUserController::__invoke
* @see app/Http/Controllers/User/CreateUserController.php
* @route '/api/user'
*/
const CreateUserController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateUserController.url(options),
    method: 'post',
})

CreateUserController.definition = {
    methods: ["post"],
    url: '/api/user',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\User\CreateUserController::__invoke
* @see app/Http/Controllers/User/CreateUserController.php
* @route '/api/user'
*/
CreateUserController.url = (options?: RouteQueryOptions) => {
    return CreateUserController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\User\CreateUserController::__invoke
* @see app/Http/Controllers/User/CreateUserController.php
* @route '/api/user'
*/
CreateUserController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateUserController.url(options),
    method: 'post',
})

export default CreateUserController